import {isObject} from "lodash";

export const isFirebaseTimestamp = (timestamp) => {
    return isObject(timestamp) && ('toDate' in timestamp);
};